/**
 * @Description: 客户端应用程序的版本发布信息相关接口
 */
import { ContentType, Method } from 'axios-mapper'
import https from '@/utils/https'
import { RootObject } from '@/model/rootObject'
import { PageRespModel } from '@/model/pageRespModel'
import { Route } from '@/constant/route'
import {
  ApplicationVersionModel,
  ApplicationVersionSearchModel,
  ApplicationVersionPageSearchModel,
  ApplicationVersionAddModel,
  ApplicationVersionUpdateModel,
  IdsModel
} from '@/model/product/ApplicationVersionModel'

const baseUrl = Route.product + '/applicationVersion'

/**
 * 搜索分页数据
 */
export const pageSearchApplicationVersion = (param: ApplicationVersionPageSearchModel) => {
  return https().request<RootObject<PageRespModel<ApplicationVersionModel>>>(baseUrl.concat('/list'), Method.POST, param, ContentType.json)
}

/**
 * 搜索所有数据
 */
export const searchApplicationVersion = (param: ApplicationVersionSearchModel) => {
  return https().request<RootObject<ApplicationVersionModel[]>>(baseUrl.concat('/list/all'), Method.POST, param, ContentType.json)
}

/**
 * 根据ID查找数据
 */
export const getApplicationVersion = (id: number) => {
  return https().request<RootObject<ApplicationVersionModel>>(baseUrl.concat('/get/').concat(id.toString()), Method.GET, undefined, ContentType.json)
}

/**
 * 添加数据
 */
export const addApplicationVersion = (param: ApplicationVersionAddModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/add'), Method.POST, param, ContentType.json)
}

/**
 * 更新数据
 */
export const updateApplicationVersion = (param: ApplicationVersionUpdateModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/update'), Method.POST, param, ContentType.json)
}

/**
 * 删除数据
 */
export const removeApplicationVersion = (id: number) => {
  return https().request<RootObject<any>>(baseUrl.concat('/remove/').concat(id.toString()), Method.POST, undefined, ContentType.json)
}

/**
 * 批量删除数据
 */
export const batchRemoveApplicationVersion = (param: IdsModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/batch/remove'), Method.POST, param, ContentType.json)
}
